import { render, staticRenderFns } from "./_sidebarForOrdersheet.vue?vue&type=template&id=d74356d0"
import script from "./_sidebarForOrdersheet.vue?vue&type=script&lang=js"
export * from "./_sidebarForOrdersheet.vue?vue&type=script&lang=js"
import style0 from "./_sidebarForOrdersheet.vue?vue&type=style&index=0&id=d74356d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports